// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"3093":"list","3180":"story"}[chunkId] || chunkId) + "-" + {"361":"eea76f12138270a28a1b","3093":"edce189a8b15f2006fdc","3180":"f2fa9903424ccac5989c"}[chunkId] + ".css";
};